// @ts-nocheck
import { maxLineQtyRule } from './maxLineQty.js';
import { tagLimitRule } from './tagLimit.js';
import { subtotalLimitRule } from './subtotalLimit.js';

export const createRuleEngine = (initialRules = null) => {
  const rules = Array();
  if (Array.isArray(initialRules)) {
    rules.push(...initialRules);
  }
  const disabledRules = new Set();

  const register = (rule = null) => {
    if (!rule) return;
    rules.push(rule);
  };

  const setEnabled = (ruleName = '', enabled = true) => {
    if (enabled) {
      disabledRules.delete(ruleName);
      return;
    }

    disabledRules.add(ruleName);
  };

  const validate = (cartState = null, mutation = null) => {
    let nextMutation = mutation;

    for (const rule of rules) {
      if (!rule || typeof rule.validate !== 'function') continue;

      const ruleName = typeof rule.name === 'string' ? rule.name : '';
      if (disabledRules.has(ruleName)) continue;

      const result = rule.validate(cartState, nextMutation);
      if (!result.allowed) {
        return result;
      }

      nextMutation = result.modifiedMutation || nextMutation;
    }

    return {
      allowed: true,
      modifiedMutation: nextMutation,
    };
  };

  return {
    register,
    setEnabled,
    validate,
  };
};

export const createDefaultRules = () => [maxLineQtyRule(), tagLimitRule(), subtotalLimitRule()];
